import React, { useState, useEffect, useMemo } from "react";

import "../../assets/css/styles.css";
import "../../assets/libs/bootstrap/css/bootstrap.min.css";
import Favoritecontent from "../../components/favorite/favorite_content";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import Spinner from "../../components/Spinner/spinner";
import Cookies from "js-cookie";
import api from "../../api";
import useInboundSocket from "../../hooks/useInboundSocket";

const Favorites = (max) => {
  const [loading, setLoading] = useState(true);
  const [showSpinner, setShowSpinner] = useState(false);
  const [experts, setExperts] = useState([]);
  const [totalWishlist, setTotalWishlist] = useState(0);
  const baseUrl = process.env.REACT_APP_BASE_URL;
  const navigate = useNavigate();
  useEffect(() => {
    const token = localStorage.getItem(`${process.env.REACT_APP_LOCAL_TOKEN}`);
    const token_horoscope = localStorage.getItem(
      `${process.env.REACT_APP_LOCAL_TOKEN_HOROSCOPE}`,
    );
    if (!token && !token_horoscope) {
      navigate("/signin", { replace: true });
    }
    fetchedData();
  }, []);

  const fetchedData = async () => {
    try {
      setShowSpinner(true);
      const response = await api.get(`/content/wishlist`);

      setExperts(response.data.data);
      setTotalWishlist(response.data.total);
    } catch (error) {
      console.log(error);
    } finally {
      setShowSpinner(false);
    }
  };
    const getInboundExtensions = (experts = []) => {
    const extensionsSet = new Set();

    experts.forEach((expert) => {
      expert.services?.forEach((service) => {
        if (service.call_type === "prn" || service.call_type === "credit") {
          service.extensions?.forEach((ext) => {
            if (ext.type === "inbound" && ext.data) {
              extensionsSet.add(ext.data);
            }
          });
        }
      });
    });

    return Array.from(extensionsSet);
  };
    const inboundExtensions = useMemo(
      () => getInboundExtensions(experts),
      [experts],
    );
  const inboundStatuses = useInboundSocket(inboundExtensions);

  useEffect(() => {
    const start = Date.now();
  }, []);

  return (
    <>
      {showSpinner ? (
        <Spinner />
      ) : (
        <div className="row m-0">
          <Favoritecontent cards={experts} total={totalWishlist} max={max}  inboundStatuses={inboundStatuses} />
        </div>
      )}
    </>
  );
};

export default Favorites;
